/**
 * Debug utility — conditional logging based on environment.
 * Logs are shown on localhost, *.local, and dev-manage.affcrit.com only.
 * Staging and production suppress all debug/warn output.
 */

/**
 * Returns true if running on a local or dev environment.
 * @returns {boolean}
 */
export function isDevelopment() {
    const h = window.location.hostname;
    return h === 'localhost' ||
           h === '127.0.0.1' ||
           h.endsWith('.local') ||
           h.startsWith('dev-manage.');
}

/**
 * console.log — dev/local only.
 * @param {...any} args
 */
export function debugLog(...args) {
    if (isDevelopment()) {
        console.log(...args);
    }
}

/**
 * console.warn — dev/local only.
 * @param {...any} args
 */
export function debugWarn(...args) {
    if (isDevelopment()) {
        console.warn(...args);
    }
}

/**
 * console.error — always logs (errors should be visible everywhere).
 * @param {...any} args
 */
export function debugError(...args) {
    console.error(...args);
}

/**
 * Create a module-scoped logger that prefixes every message with [module].
 *
 * Usage:
 *   import { createLogger } from './debug';
 *   const { log, warn, error } = createLogger('address-validation');
 *   log('form found', !!form);  // → [address-validation] form found true
 *
 * @param {string} module
 * @returns {{ log: Function, warn: Function, error: Function }}
 */
export function createLogger(module) {
    const tag = `[${module}]`;
    return {
        log:   (...args) => debugLog(tag, ...args),
        warn:  (...args) => debugWarn(tag, ...args),
        error: (...args) => debugError(tag, ...args),
    };
}
